import httpExpertClient from '@/plugins/httpExpertClient';

export default {
  entryIndex(entryId, currentPage, perPage) {
    return httpExpertClient.get(`train/expert/entries/${entryId}/homeworks`, {
      params: {
        page: currentPage,
        per_page: perPage,
      },
    });
  },
  taskIndex(taskId, currentPage, perPage) {
    return httpExpertClient.get(`train/expert/tasks/${taskId}/homeworks`, {
      params: {
        page: currentPage,
        per_page: perPage,
      },
    });
  },
  show(id) {
    return httpExpertClient.get(`train/expert/homeworks/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/expertApis/train/api-homework.js